import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie';

export default function AfterEffect({url, width, iconColor, height, play, loop, eventListeners, ...rest}){
  const [loading,  setLoading] = useState(true);
  const [data,  setData] = useState(null);

  useEffect(() => {
    setLoading(true);
    setData(null);

    if(url){
      fetch(url)
      .then(response => response.json())
      .then(data => {
        setData(data);
        setLoading(false);
      });
    }
  }, [url]);

  const options = {
    loop: loop,
    autoplay: false,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
    ...rest,
    animationData: data
  }

  return (
    <Lottie
      options={options}
      height={parseInt(height)}
      width={parseInt(width)}
      style={{ margin: "0px", color: iconColor }}
      isStopped={!play}
      eventListeners={eventListeners}
    />
  );
}